import script from "./CDivider.vue?vue&type=script&lang=ts&setup=true"
export * from "./CDivider.vue?vue&type=script&lang=ts&setup=true"

import "./CDivider.vue?vue&type=style&index=0&id=90d7f77a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d7f77a"]])

export default __exports__